import React from 'react';
import { Theme, Font, Color, Style, ChevronRight } from '@menuzen/icon/build/outline';
import Dialog, { DialogProps } from '../../../../components/dialog/Dialog';
import { MODAL } from '../config';
import LinkIcon from '../../../../components/icon/LinkIcon';

interface DesignSettingModalProps extends DialogProps {
    onClickItem: (item: string) => void;
}

const DesignSettingModal: React.FC<DesignSettingModalProps> = ({ onClickItem, ...props }) => {
    const handleClickBackground = () => {
        onClickItem(MODAL.BACKGROUND_SETTING);
    };

    return (
        <Dialog {...props}>
            <div className="mt-20 px-30 pb-40">
                <div
                    className="flex items-center justify-between py-12 border-b border-primary-40 cursor-pointer"
                    onClick={() => onClickItem(MODAL.CHOOSE_THEME)}
                >
                    <div className="text-20 h-35 w-35 rounded-5 flex items-center justify-center bg-started mr-8">
                        <Theme />
                    </div>
                    <div className="flex-grow text-left text-18 leading-none">Browse Theme</div>
                    <div className="text-20 text-primary-50">
                        <ChevronRight />
                    </div>
                </div>
                <div
                    className="flex items-center justify-between py-12 border-b border-primary-40 cursor-pointer"
                    onClick={handleClickBackground}
                >
                    <div className="text-20 h-35 w-35 rounded-5 flex items-center justify-center bg-started mr-8">
                        <LinkIcon />
                    </div>
                    <div className="flex-grow text-left text-18 leading-none">Background</div>
                    <div className="text-20 text-primary-50">
                        <ChevronRight />
                    </div>
                </div>
                <div
                    className="flex items-center justify-between py-12 border-b border-primary-40 cursor-pointer"
                    onClick={() => onClickItem(MODAL.COLOR_SETTING)}
                >
                    <div className="text-20 h-35 w-35 rounded-5 flex items-center justify-center bg-started mr-8">
                        <Color />
                    </div>
                    <div className="flex-grow text-left text-18 leading-none">Colors</div>
                    <div className="text-20 text-primary-50">
                        <ChevronRight />
                    </div>
                </div>
                <div
                    className="flex items-center justify-between py-12 border-b border-primary-40 cursor-pointer"
                    onClick={() => onClickItem(MODAL.FONT)}
                >
                    <div className="text-20 h-35 w-35 rounded-5 flex items-center justify-center bg-started mr-8">
                        <Font />
                    </div>
                    <div className="flex-grow text-left text-18 leading-none">Fonts</div>
                    <div className="text-20 text-primary-50">
                        <ChevronRight />
                    </div>
                </div>
                <div
                    className="flex items-center justify-between py-12 border-b border-primary-40 cursor-pointer"
                    onClick={() => onClickItem(MODAL.STYLE_SETTING)}
                >
                    <div className="text-20 h-35 w-35 rounded-5 flex items-center justify-center bg-started mr-8">
                        <Style />
                    </div>
                    <div className="flex-grow text-left text-18 leading-none">Style</div>
                    <div className="text-20 text-primary-50">
                        <ChevronRight />
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default DesignSettingModal;
